/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIMenuItem } from '@/models/api/menu-item.model'

const resource = {
    main: 'services',
    module: 'menu-items'
}

export class MenuItemServices {
    public static getMenuItems () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getMenuItemPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getMenuItemById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createMenuItem (params: APIMenuItem) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editMenuItem (id: number, params: APIMenuItem) {
        return service.put(`${resource.main}/${resource.module}/${id}`, params)
    }

    public static deleteMenuItem (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }
}
